export default "__VITE_ASSET__Gs9L_bg___"